/* eslint-disable no-undef */
import HomeImg from '/public/images/hero-home-bg.webp'
import OrganicImg from '/public/images/hero-organic-bg.webp'
import PaidImg from '/public/images/hero-paid-bg.webp'

import { KONDUTO_URL, POSITIVE_CONSUMER_URL } from '@/constants/links'

export const HERO_IMAGES = {
  paid: PaidImg,
  organic: OrganicImg,
  home: HomeImg
}

export const HERO_TEXTS = {
  home: {
    title: 'Somos a Equifax BoaVista',
    subtitle:
      'Uma empresa global que oferece dados para análise de crédito de pessoas e empresas.'
  },
  organic: {
    title: 'Contrate agora mesmo um plano Pós-pago!',
    subtitle:
      'Com nosso plano pós-pago, você acessa dados atualizados sobre seus clientes, garantindo decisões mais seguras e assertivas para o seu negócio.'
  },
  paid: {
    title: 'Evite surpresas!',
    subtitle:
      'Consulte CNPJ e CPF dos seus clientes e saiba com quem está negociando.'
  }
}

export const ANCHORS = [
  {
    id: 'hero-card-postpaid',
    icon: 'equifax-report',
    text: 'Planos Pós-pago',
    url: '/planos'
  },
  {
    id: 'hero-card-cnpj',
    badge_text: 'Grátis',
    icon: 'equifax-graphic-analysis',
    text: 'Consultar meu CNPJ',
    url: `${basePath}formulario/consultar`
  },
  {
    id: 'hero-card-cpf',
    icon: 'equifax-user-analysis',
    text: 'Consultar meu CPF',
    url: POSITIVE_CONSUMER_URL,
    target: '_blank'
  },
  {
    id: 'hero-card-prepaid',
    icon: 'equifax-building-search',
    text: 'Recarga Pré-pago',
    url: `${urlEquifaxOrganic}/consultas-pre-pago/`
  },
  {
    id: 'hero-card-antifraud',
    icon: 'equifax-shield-4',
    text: 'Conhecer Antifraude',
    url: KONDUTO_URL,
    target: '_blank'
  }
]
